/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductClaimSummary } from './ProductClaimSummary';
import {
    ProductClaimSummaryFromJSON,
    ProductClaimSummaryFromJSONTyped,
    ProductClaimSummaryToJSON,
    ProductClaimSummaryToJSONTyped,
} from './ProductClaimSummary';

/**
 * 
 * @export
 * @interface PagedAndSyncedResultProductClaimSummary
 */
export interface PagedAndSyncedResultProductClaimSummary {
    /**
     * 
     * @type {Array<ProductClaimSummary>}
     * @memberof PagedAndSyncedResultProductClaimSummary
     */
    content: Array<ProductClaimSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultProductClaimSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultProductClaimSummary
     */
    totalPages: number;
    /**
     * 
     * @type {Date}
     * @memberof PagedAndSyncedResultProductClaimSummary
     */
    lastSyncedAt?: Date;
}

/**
 * Check if a given object implements the PagedAndSyncedResultProductClaimSummary interface.
 */
export function instanceOfPagedAndSyncedResultProductClaimSummary(value: object): value is PagedAndSyncedResultProductClaimSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedAndSyncedResultProductClaimSummaryFromJSON(json: any): PagedAndSyncedResultProductClaimSummary {
    return PagedAndSyncedResultProductClaimSummaryFromJSONTyped(json, false);
}

export function PagedAndSyncedResultProductClaimSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedAndSyncedResultProductClaimSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(ProductClaimSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
    };
}

export function PagedAndSyncedResultProductClaimSummaryToJSON(json: any): PagedAndSyncedResultProductClaimSummary {
    return PagedAndSyncedResultProductClaimSummaryToJSONTyped(json, false);
}

export function PagedAndSyncedResultProductClaimSummaryToJSONTyped(value?: PagedAndSyncedResultProductClaimSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(ProductClaimSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
    };
}

